import { Select, Stack, Text } from '@mantine/core';
import { ClientSelectOptionLabel } from '../../../components/ClientSelectOptionLabel';
import { buildClientSelectOptions } from '../../../lib/clientSelectOptions';
import { zoomSidebarComboboxProps } from '../lib/zoomSidebarComboboxProps';

export interface TreatmentPlanParticipantOption {
  patientId: string;
  name: string;
  email?: string;
  initials?: string;
}

interface TreatmentPlanClientSelectProps {
  options: TreatmentPlanParticipantOption[];
  selectedPatientId: string | undefined;
  onSelectedPatientChange: (patientId: string) => void;
}

export function TreatmentPlanClientSelect({
  options,
  selectedPatientId,
  onSelectedPatientChange,
}: TreatmentPlanClientSelectProps): JSX.Element {
  const data = buildClientSelectOptions(
    options.map((option) => ({
      id: option.patientId,
      name: option.name,
      email: option.email,
    })),
  );

  return (
    <Stack gap={4}>
      <Select
        label="Client treatment plan"
        description="Select a group participant to view their treatment plan."
        data={data}
        value={selectedPatientId ?? null}
        onChange={(value) => {
          if (value) onSelectedPatientChange(value);
        }}
        searchable
        required
        allowDeselect={false}
        disabled={data.length === 0}
        comboboxProps={zoomSidebarComboboxProps()}
        renderOption={({ option }) => <ClientSelectOptionLabel label={option.label} />}
      />
      {data.length === 0 ? (
        <Text size="xs" c="dimmed">
          No active group participants on this appointment.
        </Text>
      ) : null}
    </Stack>
  );
}
